import { CameraOnlineStatus } from "@app/main/components/videos/models/camera-online-status";
import { IApplicationCameraRequest, IConfigCameraRequest } from "@app/main/modules/foundation/_routes/rv-lite/camera-config/camera-configuration.models";
import { IConfigurationUpdate } from "@app/services/cameraCommunicationServer.service";
import { AccountFeatures } from "@enums/account/AccountFeature";
import { IBasicProductModel } from "./IProductUiViewModel";
import { IVehiclePeripheralMapping, IVehicleUnitMapping } from "./IVehiclePeripheralMapping";

export enum SavedState {
    NoSaveRequired,
    AddedRequiresSave,
    RemovedRequiresSave
}

export interface IUnit extends IPeripheralUnitMetaData {
    Id?: number;
    Serial?: string;
    ProductId?: number;
    Product?: IBasicProductModel;

    Imei?: string;
    SimId?: number;
    StartUtc?: Date;

    // ---

    savedState?: SavedState;
    unitLocation?: string;
    type?: "Unit" | "Peripheral";
    vehicleMapping?: IVehicleUnitMapping;
}

export interface IPeripheral extends IUnit {
    TimezoneSetting?: ITimezoneSetting;
    DaylightSavingsTime?: boolean;
    VehiclePeripheralMappings?: IVehiclePeripheralMapping[];
    // ---

    dirtySerial?: string; // storing a queued change to Serial before submitting to API
    uninstallSerial?: boolean; // storing a queued change to Serial before submitting to API

    isLiveStreamCam?: boolean;
    rtlConfigUpdateHistory?: IConfigurationUpdate[]; // Deprecating when CommServer closed down
    veriConfigUpdateHistory?: IConfigCameraRequest[];
    veriAppUpdateHistory?: IApplicationCameraRequest[];
}

export interface IConfigurableCameraDevice extends IPeripheral {
    currentConfig?: string;
    currentTelematicsAppVersion?: string;
    currentUpdaterAppVersion?: string;
    currentFW?: string;
    onlineStatus?: CameraOnlineStatus;
    migrationStatus?: CommserverMigrationStatus;
    resellerId?: number;
    cameraFootageStart?: Date;
}

export enum CommserverMigrationStatus {
    Required,
    InProgress,
    Completed
}

export interface IViewCommissionPeripheral extends IPeripheral {
    showDiagnostics: boolean
}

// Used for UI specific data
export interface IPeripheralUnitMetaData {
    primaryFeature?: AccountFeatures;
    productVendorString?: string;
    name?: string;
    icon?: string;
}
